import React from 'react'
import Styles from './TerminarTrabajoCajas.module.css'
import { Form, Input } from 'semantic-ui-react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import SubmitButton from '../../submitButton/submitButton'

class TerminarTrabajoCajas extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            trabajo: {
                ...props.trabajo,
                mediosBotes:0,
                precioCaja:props.trabajo.cajas6Precio,
                precio:0,
            },
            mensajes: {
                error: false,
            },
        }
    }
    handleChange = (e, { value, name }) => {
        const trabajo = { ...this.state.trabajo }
        trabajo[name] = Number(value)
        trabajo.precio = +((trabajo.mediosBotes * trabajo.precioCaja)/4).toFixed(2)
        this.setState({ trabajo })
    }
    handleSubmit = async (event) => {
        event.preventDefault()
        const trabajo = { ...this.state.trabajo }
        if (trabajo.mediosBotes === 0) {
            const mensajes = { ...this.state.mensajes }
            mensajes.error = true
            this.setState({ mensajes: mensajes })
            return null
        }
        const batch = firebase.firestore().batch()
        const pagos = firebase.firestore().collection('Pagos')
        const prod = firebase.firestore().collection('Produccion')
        console.log(Number(trabajo.area.split('/')[0]))
        const sector = (await firebase.firestore().collection('Zonas').where('sector', '==', Number(trabajo.area.split('/')[0])).get()).docs[0]
        batch.update(firebase.firestore().collection('TareasAsignadas').doc(trabajo.trabajoID), {
            estado: "completado",
            precioTotal: this.state.trabajo.precio,
            totalCajas: +(trabajo.mediosBotes / 4).toFixed(1),
            fechaCompletado: firebase.firestore.FieldValue.serverTimestamp(),
        })
        if (trabajo.nomina === 'tarea')
            batch.set(pagos.doc(), {
                trabajoId: trabajo.trabajoID,
                empleado: trabajo.empleados[0],
                nombreActividad: trabajo.nombreActividad,
                descripcion:trabajo.descripcion,
                dificultad: trabajo.dificultad,
                totalCajas: +(trabajo.mediosBotes / 4).toFixed(2),
                cajas6Precio:trabajo.precioCaja,
                unidades: 'medios botes',
                precio: trabajo.precio,
                areaHecha: trabajo.area,
                fecha: firebase.firestore.FieldValue.serverTimestamp(),
                estado: 'pendiente'
            })
        batch.set(prod.doc(), {
            empleado: trabajo.empleados[0],
            dificultad: trabajo.dificultad,
            cajas6Precio: trabajo.nomina === 'tarea' ? trabajo.precioCaja : 0,
            nomina: trabajo.nomina,
            totalCajas: +(trabajo.mediosBotes / 4).toFixed(2),
            sector: sector.data().sector,
            variedad: sector.data().variedad,
            fruta: trabajo.nombreActividad.split('Piscar ')[1],
            fecha: firebase.firestore.FieldValue.serverTimestamp(),
        })
        batch.commit()
            .then(() => {
            })
            .catch(e => {
                alert(e)
            })
    }
    render() {
        return (
            <section>
                <Form>
                    <div className={Styles.inputGroup}>
                        <p>Medios Botes Entregados:</p>
                        <div className={Styles.inputs}>
                            <Input className={Styles.input} label='Medios botes' name='mediosBotes' type='number' value={this.state.trabajo.mediosBotes} onChange={this.handleChange}></Input>
                        </div>
                    </div>
                    <div className={Styles.inputGroup}>
                        <p>Precio:</p>
                        <div className={Styles.inputs}>
                            <Input className={Styles.input} label='Precio' value={this.state.trabajo.precioCaja/4} disabled></Input>
                        </div>
                    </div>
                    <div className={Styles.input}>
                        <p>Total</p>
                        <Input value={this.state.trabajo.precio} disabled></Input>
                    </div>
                    <SubmitButton handleSubmit={this.handleSubmit}>
                        Completar
                    </SubmitButton>
                </Form>
            </section>
        )
    }
}
export default TerminarTrabajoCajas